// Smooth scroll-to-section helper (native, reliable).
export const lenisRef = { current: null };

export function scrollToId(id, offset = -70) {
  const el = document.getElementById(id);
  if (!el) return;
  const y = el.getBoundingClientRect().top + window.scrollY + offset;
  window.scrollTo({ top: y, behavior: "smooth" });
}
